import { Stack, StackProps } from "@mui/material";

interface Props extends StackProps {
  children: React.ReactNode;
}

const WhiteCard = ({ children, sx, ...props }: Props) => {
  return (
    <Stack
      gap={4}
      {...props}
      sx={{
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0px 3px 17px 0px rgba(0, 0, 0, 0.10)",
        ...sx,
      }}
    >
      {children}
    </Stack>
  );
};

export default WhiteCard;
